import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { PlusIcon } from '@/icons';
import { AccordionContentItemWithCheckbox } from '@/module/public/components/AsideFilter/SubjectAccordion';
import { usePublicCategories, usePublicCategoryFilter } from '@/module/public/hooks';
import { usePublicMetaFilter } from '@/module/public/hooks/usePublicMetaFilter';
import { Button } from '@/ui_v3';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/ui_v3/components/accordion';
import { isAllGrades } from '@/views/build/util';
export const PublisherAccordion = () => {
  const {
    selectedPublishers,
    handleSelectedPublishers
  } = usePublicMetaFilter();
  const {
    selectedGrades
  } = usePublicCategoryFilter();
  const {
    publishers
  } = usePublicCategories();
  const {
    t
  } = useTranslation(['common']);
  const contentRef = useRef<HTMLDivElement>(null);
  const [limit, setLimit] = useState(6);
  const isShoreMore = limit < publishers.length;
  const isOnlyAllGradesSelected = selectedGrades.length === 1 && isAllGrades(selectedGrades[0]);
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  }, [limit]);
  if (publishers.length === 0 || isOnlyAllGradesSelected) return null;
  return <AccordionItem value={'publisher'} data-sentry-element="AccordionItem" data-sentry-component="PublisherAccordion" data-sentry-source-file="PublisherAccordion.tsx">
      <AccordionTrigger data-sentry-element="AccordionTrigger" data-sentry-source-file="PublisherAccordion.tsx">
        {t('common:schoolInfo.textbookPublisher')}
      </AccordionTrigger>
      <AccordionContent ref={contentRef} className={'flex flex-col gap-md p-md'} data-sentry-element="AccordionContent" data-sentry-source-file="PublisherAccordion.tsx">
        {selectedGrades.length === 0 ? <span className={'text-body-md-medium text-assistive'}>
            {t('common:required.firstGrade')}
          </span> : <>
            {publishers.slice(0, limit).map(publisher => <AccordionContentItemWithCheckbox onCheckedChange={() => {
          handleSelectedPublishers(publisher.value);
        }} key={publisher.value} id={publisher.value} checked={selectedPublishers.includes(publisher.value)} name={publisher.label} />)}
            {isShoreMore && <div className={'flex w-full pr-md'}>
                <Button onClick={() => setLimit(publishers.length)} className={'w-full'} size={'sm'} intent={'neutral'} variant={'outlined'}>
                  <PlusIcon size={'xs'} />
                  {t('common:common.moreView')}
                </Button>
              </div>}
          </>}
      </AccordionContent>
    </AccordionItem>;
};